import * as React from "react";
import { ScrollToBottomIfLarge } from "source/app/services/UI/UI";

export function RootNodeNameText({ name }: { name: string; }) {
    React.useEffect(() => {
        ScrollToBottomIfLarge("scrollTarget_rootNodeName");
    }, [name]);

    return <div id="scrollTarget_rootNodeName">{name}</div>;
}
